import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axios";

const initialState = {
  bhiLoading: false,
  bhiData: {},
  allBHIPatients: [],
};

const alterBHIDiagnosisLogic = (state, { payload }) => {
  state.bhiData.diagnosis = payload;
};

export const getAllBHIPatientsLogic = createAsyncThunk(
  "patient/bhi/all",
  () => {
    return axiosInstance.get("/api/bhi-patient/", {
      headers: {
        Authorization: `JWT ${localStorage?.access}`,
        "Content-Type": "application/json",
      },
    });
  }
);

export const getPatientBHIDataLogic = createAsyncThunk("patient/bhi", (id) => {
  let config = {
    method: "post",
    url: `/api/bhi-patient/get-patient-bhi-data/`,
    headers: {
      Authorization: `JWT ${localStorage.access}`,
    },
    data: JSON.stringify({
      patient_id: id,
    }),
  };

  return axiosInstance.request(config);
});

const bhiAPICalls = {
  //* BHI Patient Data Promises
  [getPatientBHIDataLogic.pending]: (state) => {
    state.bhiLoading = true;
  },
  [getPatientBHIDataLogic.fulfilled]: (state, { payload }) => {
    state.bhiData = payload.data;
    state.bhiLoading = false;
  },
  [getPatientBHIDataLogic.rejected]: (state, action) => {
    state.bhiLoading = false;
  },

  [getAllBHIPatientsLogic.pending]: (state) => {
    state.bhiLoading = true;
  },
  [getAllBHIPatientsLogic.fulfilled]: (state, { payload }) => {
    state.allBHIPatients = payload?.data;
    state.bhiLoading = false;
  },
  [getAllBHIPatientsLogic.rejected]: (state) => {
    state.bhiLoading = false;
  },
};

const bhiSlice = createSlice({
  name: "bhi",
  initialState,
  extraReducers: {
    ...bhiAPICalls,
  },
  reducers: {
    fetchBHIData: getPatientBHIDataLogic,
    alterBHIDiagnosis: alterBHIDiagnosisLogic,
    fetchAllBHIPatients: getAllBHIPatientsLogic,
  },
});

export const { fetchBHIData, alterBHIDiagnosis, fetchAllBHIPatients } =
  bhiSlice.actions;
export default bhiSlice.reducer;
